var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"messageListContainer",staticClass:"message-list-container"},[_c('ul',{staticClass:"message-list"},_vm._l((_vm.messages),function(message,i){return _c('li',{key:`message-${i}`},[_c('Message',{attrs:{"message":message,"is-queued":_vm.isInQueue(message.id),"fontSize":_vm.fontSize}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }